import type { CSSProperties, ReactNode } from 'react'
import { Icon, type IconName } from '@/components/icons/icon'
import { cn } from '@/lib/utils'

interface EmptyStateProps {
  /** The tinted icon tile (`.eic`). */
  icon?: IconName
  /** `acc` for an error-flavoured empty state ("Analytics unavailable"). */
  tone?: 'act' | 'acc'
  title: ReactNode
  body?: ReactNode
  /** The button(s) under the body. */
  action?: ReactNode
  className?: string
  /** The prototype pads some empties more, e.g. `{ padding: '64px 20px' }`. */
  style?: CSSProperties
}

/** The dashed first-run panel (`.empty`): icon, h3, one sentence, one action. */
export function EmptyState({ icon, tone = 'act', title, body, action, className, style }: EmptyStateProps) {
  return (
    <div className={cn('empty', className)} style={style}>
      {icon ? (
        <span
          className="eic"
          aria-hidden="true"
          style={tone === 'acc' ? { background: 'var(--acc-quiet)', color: 'var(--acc-text)' } : undefined}
        >
          <Icon name={icon} />
        </span>
      ) : null}
      <h3>{title}</h3>
      {body ? <p>{body}</p> : null}
      {action}
    </div>
  )
}
